import { Variant } from '../../types'
import {
  STANDARD_FLOWER_SIZE_ID,
  LARGE_FLOWER_SIZE_ID,
  GIANT_FLOWER_SIZE_ID,
} from '../../constants'
import { useProductsLocaleText } from '../../locale'

export const getVariantDescription = (
  variant: Pick<Variant, 'key' | 'subtitle' | 'dimensions'>,
  localiseText: ReturnType<typeof useProductsLocaleText>,
) => {
  switch (variant.key) {
    case STANDARD_FLOWER_SIZE_ID:
      return localiseText('common.flower_variant_description_standard')
    case LARGE_FLOWER_SIZE_ID:
      return localiseText('common.flower_variant_description_large')
    case GIANT_FLOWER_SIZE_ID:
      return localiseText('common.flower_variant_description_giant')
    default:
      return variant.subtitle || variant.dimensions?.description
  }
}
